<template>
    <div id="partslist-edit-page">
        <loader v-if="loading" />
        <template v-else>
            <actions-menu>
                <actions-menu-item
                    icon="arrow-left"
                    :action="
                        () => $router.push('/productpage/' + productIdParam)
                    "
                    :label="trans('pages.partslist_edit.to_product')" />
                <actions-menu-item
                    icon="arrow-left"
                    :action="
                        () =>
                            $router.push(
                                '/partslistview/' +
                                    productIdParam +
                                    '/' +
                                    partslistIdParam
                            )
                    "
                    :label="trans('pages.partslist_edit.to_partslist')" />
                <actions-menu-item
                    :action="removePartslist"
                    class="alert"
                    :v4="true"
                    icon="trash-o"
                    :label="trans('pages.partslist_edit.delete')" />
            </actions-menu>
            <div class="leftcolumn">
                <h1>{{ trans('pages.partslist_edit.partslist') }}</h1>
                <div class="paintlistviewkey">{{ trans('pages.partslist_edit.partslist_number') }}</div>
                <span id="partslistcreateid">{{ partslist.partslistId }}</span>
                <br />
                <div class="paintlistheader">
                    <div class="paintlistviewdiv">
                        <div class="paintlistdivtitle">{{ trans('pages.partslist_edit.color') }}</div>
                        <div class="paintlistdivelement">
                            <div class="paintlistelementtitle">{{ trans('pages.partslist_edit.ral_color') }}</div>
                            <div
                                class="paintlistelementvalue"
                                id="partslistcreateral">
                                {{ partslist.ralnr }} {{ partslist.raltype }}
                            </div>
                        </div>
                        <div class="paintlistdivelement">
                            <div class="paintlistelementtitle">
                                {{ trans('pages.partslist_edit.powder_number') }}
                            </div>
                            <div class="paintlistelementvalue">
                                {{ partslist.code }}
                            </div>
                        </div>
                        <div class="paintlistdivelement">
                            <div class="paintlistelementtitle">{{ trans('pages.partslist_edit.brand') }}</div>
                            <div
                                class="paintlistelementvalue"
                                id="partslistcreatemerk">
                                {{ partslist.producent }}
                            </div>
                        </div>
                    </div>
                    <div class="paintlistviewdiv">
                        <div class="paintlistdivtitle">{{ trans('pages.partslist_edit.package_content') }}</div>
                        <div class="paintlistdivelement">
                            <div class="paintlistelementtitle">
                                {{ trans('pages.partslist_edit.total_count') }}
                            </div>
                            <div
                                class="paintlistelementvalue paintlistbold"
                                id="partslistcreatecount">
                                {{ partslist.totalCount }}
                            </div>
                        </div>
                        <div class="paintlistdivelement">
                            <div class="paintlistelementtitle">{{ trans('pages.partslist_edit.total_area') }}</div>
                            <div
                                class="paintlistelementvalue paintlistbold"
                                id="partslistcreatearea">
                                {{ partslist.totalArea.toFixed(2) }} m&sup2;
                            </div>
                        </div>
                    </div>
                </div>

                <p>{{ trans('pages.partslist_edit.profiles_in_package') }}</p>
                <div id="partslistcreate">
                    <div
                        v-for="(record, index) in records"
                        :id="'paintlistrecord' + record.ID"
                        :key="record.recordnr + '.' + index"
                        class="paintlistrecord">
                        <div class="paintlistleft">
                            <img
                                :src="
                                    Config.url +
                                    '/profile/fetchImage/?profileId=' +
                                    record.profile
                                "
                                :alt="record.code" />
                        </div>
                        <div class="paintlistcenter">
                            <div class="paintlistred">
                                {{ record.description }}
                            </div>
                            <div class="paintlistdefault">
                                {{ record.code }}
                            </div>
                            <div class="paintlistitalic">
                                {{ trans('pages.partslist_edit.profile_circumference') }} {{ record.contour }}
                            </div>
                        </div>
                        <div class="paintlistright">
                            <div class="paintlistbold">
                                {{ trans('pages.partslist_edit.length') }}
                                <template v-if="record.isPart == 1">
                                    {{ trans('pages.partslist_edit.piece') }}
                                </template>
                                <template v-else>
                                    {{ record.length }}
                                </template>
                            </div>
                            <div class="paintlistbold">
                                {{ trans('pages.partslist_edit.count') }} {{ record.count }}
                            </div>
                            <div class="paintlistitalic">
                                {{ trans('pages.partslist_edit.total_area_abbr') }} {{ record.area }} m&sup2;
                            </div>
                            <ui5-button
                                @click="
                                    $router.push(
                                        '/partslisteditline/' +
                                            productIdParam +
                                            '/' +
                                            partslistIdParam +
                                            '/' +
                                            record.ID
                                    )
                                ">
                                {{ trans('pages.partslist_edit.adjust_line') }}
                            </ui5-button>
                            <ui5-button @click="removeRecord(record.ID)">
                                {{ trans('pages.partslist_edit.remove_line') }}
                            </ui5-button>
                        </div>
                    </div>
                </div>
                <ui5-button
                    @click="
                        $router.push(
                            '/partslistcreateline/' +
                                productIdParam +
                                '/' +
                                partslistIdParam
                        )
                    ">
                    {{ trans('pages.partslist_edit.add_line') }}
                </ui5-button>
            </div>
        </template>
    </div>
</template>
<script>
import IsDebugMixin from '../mixins/is-debug';
import IdParamMixin from '../mixins/id-param';
import partslistApi from '../api/partslist';
import ErrorHelper from '../helpers/ErrorHelper';
import Loader from '../components/loader/Loader';
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import { showConfirmDialog, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { Loader, ActionsMenu, ActionsMenuItem },
    mixins: [
        IsDebugMixin,
        IdParamMixin('productIdParam', 'partslistIdParam'),
        NavigationFunctionsMixin,
        localization,
    ],
    computed: {
        Config: () => Config,
        productIdParam() {
            return this.$route.params.productId;
        },
        partslistIdParam() {
            return this.$route.params.partslistId;
        },
    },
    data() {
        return {
            loading: false,
            partslist: null,
            records: null,
        };
    },
    methods: {
        load() {
            this.loading = true;
            this.$store.commit(
                'general/setPageTitle',
                `${this.trans('pages.partslist_edit.edit_partslist_number')} ${this.partslistIdParam}, ${this.trans('pages.partslist_edit.product_number')} ${this.productIdParam}`,
                { root: true }
            );
            partslistApi
                .fetch(this.partslistIdParam, this.productIdParam)
                .then((response) => {
                    const partslistData = response.data.data;
                    this.partslist = partslistData.partslist;
                    this.records = partslistData.records;
                })
                .catch((error) => {
                    const translations = {
                        'partslist.notfound': this.trans('pages.partslist_edit.partslist_not_found'),
                    };
                    ErrorHelper.displayError(error, translations);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        removePartslist() {
            showConfirmDialog({
                title: this.trans('pages.partslist_edit.delete_partslist_title'),
                content: this.trans('pages.partslist_edit.delete_partslist_confirm'),
                confirm: () => {
                    partslistApi
                        .remove(this.partslistIdParam)
                        .then(() => {
                            this.goToProductPage(this.productIdParam);
                        })
                        .catch(() => {
                            showErrorMessage(this.trans('pages.partslist_edit.delete_failed'));
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans('pages.partslist_edit.yes'),
                cancelButton: this.trans('pages.partslist_edit.no'),
            });
        },
        removeRecord(recordId) {
            showConfirmDialog({
                title: this.trans('pages.partslist_edit.delete_partslist_line_title'),
                content: this.trans('pages.partslist_edit.delete_partslist_line_confirm'),
                confirm: () => {
                    partslistApi
                        .removeRecord(recordId)
                        .then(() => {
                            this.load();
                        })
                        .catch(() => {
                            showErrorMessage(this.trans('pages.partslist_edit.delete_failed'));
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans('pages.partslist_edit.yes'),
                cancelButton: this.trans('pages.partslist_edit.no'),
            });
        },
    },
};
</script>
